import Input from '../components/Input';
import Button from '../components/Button';
import { useState } from 'react';
import { useAuth } from "../context/AuthContext";
import logo from '../assets/Contopet-Logo_no_payoff.png';
import MyText from '../components/MyText';


export default function Login() {
    const { login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const enterPressed = (event) => {
        if (event.key === "Enter") {
            login(email, password);
        }
    }

    return (

        <div style={styles.container}>
            <div style={styles.form}>

                <div style={styles.box}>
                    <div style={styles.imgContainer}>
                        <img style={styles.image} src={logo} alt="Logo" />
                    </div>
                    <div style={styles.inputContainer}>
                        <MyText>Email</MyText>
                        <Input
                            type="email-address"
                            nRows={1}
                            placeholder={"Email"}
                            callback={(val) => setEmail(val)}
                            width="100%" />
                    </div>
                    <div style={styles.inputContainer}>
                        <MyText>Password</MyText>
                        <Input
                            type="password"
                            nRows={1}
                            placeholder={"Password"}
                            callback={(val) => setPassword(val)}
                            width="100%" 
                            pressCallback={enterPressed}
                            />
                    </div>
                    <div style={{ height: 40 }} />
                    <div style={styles.btnContainer}>
                        <Button text="Accedi" callback={() => login(email, password)} textStyle={{color: 'white'}}/>
                    </div>
                </div>
            </div>
        </div>
    );
}
const styles = {
    imgContainer: {
        // backgroundColor: '#282d68',
        // minHeight: '100vh',
        // maxHeight: '10vh',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        marginBottom: 60,
    },
    image: {
        maxHeight: '50px',
    },
    container: {
        height: "100%",
        flexDirection: 'column',
        // backgroundColor: 'red',
        backgroundColor: '#f2f2f2',
        overflowY: 'auto'
    },
    form: {
        // backgroundColor: 'red',
        // marginTop: "10%",
        width: '100%',
        height: '100%',
        gap: 0,
        display: "flex",
        flex:1,
        justifyContent: "center",
        alignItems: "center"
    },
    box: {
        backgroundColor: "white",
        border: "2px solid lightgray",
        borderRadius: 20,
        width: "100%",
        minWidth: 300,
        maxWidth: 600,
        padding:' 80px 40px',
    },
    inputContainer: {
        marginBottom: 20
    },
    btnContainer: {
        display: "flex",
        justifyContent: "center"
    }
};